import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import AppShell from "@/components/app/AppShell";
import Dashboard from "@/pages/Dashboard";
import Projects from "@/pages/Projects";
import Customers from "@/pages/Customers";
import Plots from "@/pages/Plots";
import Invoices from "@/pages/Invoices";
import Payments from "@/pages/Payments";
import Vendors from "@/pages/Vendors";
import Expenses from "@/pages/Expenses";
import Employees from "@/pages/Employees";
import ExpenseCategories from "@/pages/ExpenseCategories";
import ImpersonateExchange from "@/pages/ImpersonateExchange";
import PlanRequests from "@/pages/PlanRequests";
import PauseRequests from "@/pages/PauseRequests";
import AdminAccounts from "@/pages/AdminAccounts";
import AuditLog from "@/pages/AuditLog";
import PlotDetail from "@/pages/PlotDetail";
import Imports from "@/pages/Imports";
import CustomerPortal from "@/pages/customer/Portal";

function AppRouter() {
  const location = useLocation();
  // Detect OAuth callback synchronously via reactive hash
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/auth/impersonate" element={<ImpersonateExchange />} />
      <Route path="/portal" element={<CustomerPortal />} />
      <Route element={<AppShell />}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/customers" element={<Customers />} />
        <Route path="/plots" element={<Plots />} />
        <Route path="/plots/:pid" element={<PlotDetail />} />
        <Route path="/invoices" element={<Invoices />} />
        <Route path="/payments" element={<Payments />} />
        <Route path="/vendors" element={<Vendors />} />
        <Route path="/expenses" element={<Expenses />} />
        <Route path="/employees" element={<Employees />} />
        <Route path="/expense-categories" element={<ExpenseCategories />} />
        <Route path="/plan-requests" element={<PlanRequests />} />
        <Route path="/pause-requests" element={<PauseRequests />} />
        <Route path="/imports" element={<Imports />} />
        <Route path="/admins" element={<AdminAccounts />} />
        <Route path="/audit-log" element={<AuditLog />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster richColors position="top-right" mobileOffset={{ top: "calc(64px + env(safe-area-inset-top))" }} />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
